import PropTypes from "prop-types"
import { Button } from "@mui/material"
import SaveButton from "./save-button"

export default function MetricsSelectorFooter({ saveSelectedMetrics, deleteSelectedMetrics, canSaveView, isEditing, hasDeleteAccess, analytics, isSaving = false, isDeleting = false }) {
  return <div className="metrics-selector-footer">
    <Button color="error" disabled={!isEditing || !hasDeleteAccess || isDeleting} onClick={deleteSelectedMetrics}>
      {isDeleting ? "Deleting..." : "Delete View"}
    </Button>
    <SaveButton
      saveSelectedMetrics={saveSelectedMetrics}
      canSaveView={canSaveView}
      isEditing={isEditing}
      analytics={analytics}
      isSaving={isSaving}
    />
  </div>
}

MetricsSelectorFooter.propTypes = {
  saveSelectedMetrics: PropTypes.func.isRequired,
  deleteSelectedMetrics: PropTypes.func.isRequired,
  canSaveView: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  hasDeleteAccess: PropTypes.bool.isRequired,
  analytics: PropTypes.object,
  isSaving: PropTypes.bool,
  isDeleting: PropTypes.bool,
}
